'use client'

import Image from 'next/image'
import { Breadcrumbs } from '@dustin-web/microsite-components/src/breadcrumbs'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks/use-translations'
import type { GetProductsForManufacturerQuery } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import type { BrandPageFragment } from '@contentsite/src/graphql/generated/graphql-types'
import { BrandPageSchema } from '@contentsite/src/components/schemas/collection-page-schema'
import { ManufacturerProductsWrapper } from './sections/manufacturer-product-list'
import type { BrandContentSectionData } from './sections/types'

type Props = {
  page: BrandPageFragment
  pageData: GetProductsForManufacturerQuery
}

const Brand = ({ page, pageData }: Props) => {
  const { translate } = useTranslations()

  const breadcrumbs = page.breadcrumbs.map(breadcrumb => ({
    displayName: breadcrumb.displayName,
    url: breadcrumb.url,
    clientNavigationRoute: breadcrumb.url,
  }))

  breadcrumbs.unshift({
    displayName: translate('Header_Brands'),
    url: page.allBrandsUrl,
    clientNavigationRoute: '',
  })

  return (
    <>
      <BrandPageSchema page={page} />

      <div className="container">
        <Breadcrumbs path={breadcrumbs} />
      </div>

      <div className="container">
        <div className="row sm-gutters">
          {page.logo && (
            <div className="col-12 col-lg-3">
              <div className="c-box u-px-0 u-h-100 d-flex justify-content-center align-items-center">
                <Image unoptimized fill alt={page.header} src={page.logo.url + '?h=120'} />
              </div>
            </div>
          )}
          <div className="col-12 col-lg-9">
            <h1>{page.header}</h1>
            <div dangerouslySetInnerHTML={{ __html: page.description }}></div>
          </div>
        </div>
      </div>
      <ManufacturerProductsWrapper
        pageData={pageData}
        content={{ brandName: page.header } as BrandContentSectionData}
      />
    </>
  )
}

export default Brand
